module.exports = __webpack_public_path__ + "img/cross.62ad9681.svg";